import React from 'react';

const AutoRenewalToggle = ({ autoRenewal, setAutoRenewal }) => {
  return (
    <div className="mb-4 flex items-center justify-between bg-[#022A52] border border-[#033A6A] rounded-xl p-4">
      <div>
        <p className="font-medium text-sm">Auto-Renewal</p>
        <p className="text-xs text-gray-400 mt-0.5">
          Automatically renew before expiry using saved payment method
        </p>
      </div>
      <button
        type="button"
        onClick={() => setAutoRenewal(!autoRenewal)}
        className={`relative w-12 h-6 rounded-full transition-colors duration-200 focus:outline-none ${
          autoRenewal ? 'bg-green-500' : 'bg-gray-600'
        }`}
      >
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${
          autoRenewal ? 'translate-x-6' : 'translate-x-0'
        }`} />
      </button>
    </div>
  );
};

export default AutoRenewalToggle;